export default {
      id: "download-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#download-usage",
      toString: function () {
        return this.url;
      }
    }